<template>
    <v-container class="pa-5" fluid>
        <page-title>Zlecenia NCF</page-title>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" lg="12">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col cols="12" md="4" lg="2">
                            <v-menu
                                v-model="menuFrom"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.createdAt__gte"
                                        label="Data"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        solo
                                        hide-details
                                        append-icon
                                        clearable
                                        class="mt-0"
                                        v-on="on"
                                        @input="changeFilter"
                                        @click:clear="clearFilter('createdAt__gte')"
                                    >
                                        <template slot="append-outer">
                                            <div class="d-flex flex-wrap">
                                                <v-btn
                                                    icon
                                                    x-small
                                                    class="mt-n2"
                                                    data-sentry-label="Zmiana daty raportu"
                                                    @click="getForwardDate('createdAt__gte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-up
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn
                                                    icon
                                                    x-small
                                                    data-sentry-label="Zmiana daty raportu"
                                                    @click="getBackwardDate('createdAt__gte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-down
                                                    </v-icon>
                                                </v-btn>
                                            </div>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="filters.createdAt__gte"
                                    first-day-of-week="1"
                                    @change="changeFilter"
                                    @input="menuFrom = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="4" lg="2">
                            <v-menu
                                v-model="menuTo"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.createdAt__lte"
                                        label="Data"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        solo
                                        hide-details
                                        append-icon
                                        clearable
                                        class="mt-0"
                                        v-on="on"
                                        @input="changeFilter"
                                        @click:clear="clearFilter('createdAt__lte')"
                                    >
                                        <template slot="append-outer">
                                            <div class="d-flex flex-wrap">
                                                <v-btn
                                                    icon
                                                    x-small
                                                    class="mt-n2"
                                                    data-sentry-label="Zmiana daty raportu"
                                                    @click="getForwardDate('createdAt__lte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-up
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn
                                                    icon
                                                    x-small
                                                    data-sentry-label="Zmiana daty raportu"
                                                    @click="getBackwardDate('createdAt__lte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-down
                                                    </v-icon>
                                                </v-btn>
                                            </div>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="filters.createdAt__lte"
                                    first-day-of-week="1"
                                    @change="changeFilter"
                                    @input="menuTo = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn
                                text
                                x-small
                                data-sentry-label="Generuj raport"
                                :disabled="actionLoading.generateReportLoading"
                                @click="generateNCFJobsReportsReport"
                            >
                                <v-icon
                                    v-if="!actionLoading.generateReportLoading"
                                    small
                                    color="green"
                                >
                                    mdi-file-excel
                                </v-icon>
                                <v-progress-circular
                                    v-else
                                    indeterminate
                                    color="primary"
                                    class="mr-1"
                                    size="12"
                                    width="2"
                                />
                                Generuj raport
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="NCFJobsReports"
                        :loading="NCFJobsReportsLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :items-per-page.sync="pagination.itemsPerPage"
                        :mobile-breakpoint="0"
                        :item-class="setSelectedRow"
                        name="reportsData"
                        @pagination="updatePagination"
                    >
                        <template #item.createdAt="{item}">
                            {{ formatDate(item.createdAt) }}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import PageTitle from '@/components/common/PageTitle'
import filters from '@/mixins/dataTableFilters'
import customFilters from '@/mixins/customFilters'
import pagination from '@/mixins/dataTablePagination'
import dateFormatter from '@/mixins/dateFormatter'
import parse from '@/mixins/parse.js'
import dataTableClassSetter from '@/mixins/dataTableClassSetter'
import { errorHandler } from '@/utils/errorHandler'


export default {
    name: 'NCFJobReport',
    components: {
        PageTitle,
    },
    mixins: [
        dateFormatter,

        filters,
        pagination,
        customFilters,
        parse,
        dataTableClassSetter
    ],
    data() {
        return {
            menuFrom: false,
            menuTo: false,
            usersSearch: null,
            users: [],
            currentReportShiftSummary: null,
            reportShiftSummaryDialog: false,
            actionLoading: {
                generateReportLoading: false
            },
            actionName: null,
            headers: [
                {
                    text: 'Numer zlecenia',
                    value: 'jobNumber',
                    width: 200,
                    sortable: false,
                },
                {
                    text: 'Numer montażu',
                    value: 'ordinalNumber',
                    sortable: false,
                    align: 'center',
                },                
                {
                    text: 'Data utworzenia',
                    value: 'createdAt',
                    sortable: false,
                    align: 'center',
                },
            ],

        }
    },
    computed: {
        NCFJobsReports() {
            return this.$store.state.reportsAndAnalysis.jobs.NCFJobsReports.NCFJobsReports
        },
        NCFJobsReportsLoading() {
            return this.$store.state.reportsAndAnalysis.jobs.NCFJobsReports.NCFJobsReportsLoading
        },
        savedFilters() {
            return this.$store.state.reportsAndAnalysis.jobs.NCFJobsReports.NCFJobsReportsFilters
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] !== null && typeof filters[item] !== 'undefined') {
                    if (item == 'finishDateTime__gte') {
                        filters[item] += 'T00:00:00Z'
                    }

                    if (item == 'finishDateTime__lte') {
                        filters[item] += 'T23:59:59Z'
                    }
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
        userId() {
            return this.$store.state.user.userId
        },
    },
    beforeMount() {
        if (!this.savedPagination.pagination) {
            this.resetPagination()
        }
    },
    mounted() {
        this.$store.dispatch('administration/getUser', this.userId)
            .then(response => {
                this.user = response.data
            })
            .catch(error => {
                errorHandler(error)
            })
        this.getNCFJobs()
    },
    methods: {
        generateNCFJobsReportsReport() {
            this.actionLoading.generateReportLoading = true
            this.$store.dispatch('reportsAndAnalysis/jobs/generateNCFJobsReportsReport', {
                query: this.filterQuery,
                userEmail: this.user.email
            })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.generateReportLoading = false
                })
        },
        getBackwardDate(createdAt) {
            if (Date.parse(this.filters[createdAt])) {
                this.filters[createdAt] = this.getDayBackward(this.filters[createdAt])
                this.changeFilter()
            }
        },
        getForwardDate(createdAt) {
            if (Date.parse(this.filters[createdAt])) {
                this.filters[createdAt] = this.getDayForward(this.filters[createdAt])
                this.changeFilter()
            }
        },
        setSelectedRow(item) {
            if (item.id === this.selectedReportShiftSummaryId) {
                return 'isSelected'
            }
        },
        getNCFJobs() {
            this.$store.dispatch('reportsAndAnalysis/jobs/getNCFJobsReports', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        close() {
            this.$router.push({ name: 'reportingAndAnalysisJobsJobs' })
                .catch(error => {
                    errorHandler(error)
                })
        },
        changeFilter() {
            this.$store.dispatch('reportsAndAnalysis/jobs/setNCFJobsReportsFilters', this.filters)
                .catch(error => {
                    errorHandler(error)
                })
            this.getNCFJobs()
        },
        updatePagination(pagination) {
            this.pagination = pagination
            this.evaluateSavedPagination(this.$options.name)
            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending && !this.savedPagination.pagination) {
                this.getNCFJobs()
            }
            this.clearPaginationPending()
        }
    }
}

</script>